const schema = () => ({
  type: "object",
  required: [],
  properties: {
    lab_ids: {
      type: "array",
      title: "لابراتوار",
      items: {
        type: "string",
      },
    },
    unit_ids: {
      type: "array",
      title: "کلینیک",
      items: {
        type: "string",
      },
    },
    doctor_ids: {
      type: "array",
      title: "پزشک",
      items: {
        type: "string",
      },
    },
  },
});

export default schema;
